import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, Inject, Input, Output } from '@angular/core';
import { fromEvent } from 'rxjs';

@Directive({
  selector: '[appClicksOutside]'
})
export class ClicksOutsideDirective{
  @Output() public clickedOutside = new EventEmitter();

  constructor(
    private elementRef: ElementRef) {}
  
  @HostListener('document:click', ['$event.target'])
  public onClick(target:any){
    const clickedOutside = this.elementRef.nativeElement.contains(target);
    if(!clickedOutside){
      this.clickedOutside.emit(target);
    }
  }
}
